import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { FormattedMessage } from '../../../i18n/FormattedMessage';
import {
  UsersIcon,
  EllipsisVerticalIcon,
} from '../../../components_2/AriesIcons';

const ChatScreenHeader = ({ onGroupClick, onMoreClick, isGroupActive }) => {
  const intl = useIntl();
  return (
    <div className="chat-screen-header">
      <h1>
        <FormattedMessage id="chat.chatsTitle" defaultMessage="Chats" />
      </h1>
      <div className="chat-screen-header-actions">
        <button
          type="button"
          className={`chat-header-action ${isGroupActive ? 'is-active' : ''}`}
          aria-label={intl.formatMessage({
            id: 'chat.groupChats',
            defaultMessage: 'Group Chats',
          })}
          onClick={onGroupClick}
        >
          <UsersIcon size={20} />
        </button>
        <button
          type="button"
          className="chat-header-action"
          aria-label={intl.formatMessage({
            id: 'chat.moreOptions',
            defaultMessage: 'More options',
          })}
          onClick={onMoreClick}
        >
          <EllipsisVerticalIcon size={20} />
        </button>
      </div>
    </div>
  );
};

ChatScreenHeader.propTypes = {
  onGroupClick: PropTypes.func,
  onMoreClick: PropTypes.func,
  isGroupActive: PropTypes.bool,
};

export default ChatScreenHeader;
